exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles__childComponent___3uFai {\n  display: inline; }\n  @media (max-width: 768px) {\n    .styles__childComponent___3uFai {\n      margin-top: 10px;\n      width: 100%;\n      display: inline-block; } }\n\n.styles__childColumnComponent___26zaS {\n  margin-top: 15px; }\n", ""]);

// exports
exports.locals = {
	"childComponent": "styles__childComponent___3uFai",
	"childColumnComponent": "styles__childColumnComponent___26zaS"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/FormControls/LevelSelector/styles.scss
// module id = 2100
// module chunks = 6